"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toHubSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
// ------------------------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------
var toHubType = function (data) {
    switch (data) {
        case types_1.PrismicHubType.PRESS_RELEASE:
            return types_1.HubType.PRESS_RELEASE;
        case types_1.PrismicHubType.NEWSROOM:
            return types_1.HubType.NEWSROOM;
        case types_1.PrismicHubType.INVESTORS_PRESS_RELEASE:
            return types_1.HubType.INVESTORS_PRESS_RELEASE;
        case types_1.PrismicHubType.INVESTORS_PUBLICATION:
            return types_1.HubType.INVESTORS_PUBLICATION;
    }
};
// ------------------------------------------------------------------------------------------------
var FILTER_MAPPING = {
    filter_financialPublication: types_1.Filter.FinancialPublication,
    filter_thematic: types_1.Filter.Thematic,
    filter_format: types_1.Filter.Category,
    filter_localisation: types_1.Filter.Localization,
    filter_dateRange: types_1.Filter.DateRange,
    filter_year: types_1.Filter.Year
};
var processFilters = function (data) {
    var filters = Object.entries(data).reduce(function (acc, _a) {
        var _b;
        var k = _a[0], v = _a[1];
        return FILTER_MAPPING[k]
            ? __assign(__assign({}, acc), (_b = {}, _b[FILTER_MAPPING[k]] = fields_1.toBoolean(v), _b)) : acc;
    }, {});
    if (Object.keys(filters).length > 0) {
        return filters;
    }
    return undefined;
};
// ------------------------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------
var toHubSlice = function (data, logger) {
    var _a;
    var hubType = logger.required(toHubType((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.type));
    var filters = processFilters(data === null || data === void 0 ? void 0 : data.primary);
    if (!hubType) {
        return undefined;
    }
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.Hub)), { hubType: hubType,
        filters: filters }));
};
exports.toHubSlice = toHubSlice;
//# sourceMappingURL=hub-slice.js.map